import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useNewTranslation } from 'hooks'
import { deleteBrand, TeamState } from 'state/teams'
import { BrandState } from 'state/brands'
import Modal from 'particles/Modal'
interface DeleteBrandModalProps {
    onClose: () => void
    team: TeamState
    brand: BrandState
    onConfirm: () => void
}
const DeleteBrand: React.FC<DeleteBrandModalProps> = ({ onClose, team, brand }) => {
    const [t] = useNewTranslation()
    const dispatch = useDispatch()

    const onDeleteBrand = (brand: BrandState | undefined) => {
        brand &&
            dispatch(
                deleteBrand({
                    teamUuid: team.uuid,
                    brandUuid: brand.uuid,
                }),
            )
    }

    const handleCloseModal = (e: any): void => {
        if (e.target.id === 'pop-up-delete-modal') {
            onClose()
        }
    }

    useEffect(() => {
        window.addEventListener('click', handleCloseModal)
        return (): void => window.removeEventListener('click', handleCloseModal)
    }, [])

    return (
        <>
            {team ? (
                <Modal
                    title={t('modalWindow.confirmationMessage.deleteBrandTitle', {
                        brandName: brand?.name,
                    })}
                    subtext={t('modalWindow.confirmationMessage.deleteBrandSubtitle')}
                    onClose={onClose}
                    onConfirm={() => {
                        onDeleteBrand(brand)
                        onClose()
                    }}
                    secondaryButtonProps={{
                        label: t('button.noCancel'),
                    }}
                    primaryButtonProps={{
                        label: t('button.yesDelete'),
                    }}
                    size="m"
                    hasIcon={false}
                />
            ) : null}
        </>
    )
}

export default DeleteBrand
